var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700195 13.3L2.66979 13.2204L7.0002 8.88995L11.3306 13.2204L13.3002 13.3L13.2206 11.3304L8.89019 6.99995L13.2206 2.66955L13.3002 0.699951L11.3306 0.779549L7.0002 5.10995L2.66979 0.779549L0.700195 0.699951L0.779793 2.66955L5.1102 6.99995L0.779793 11.3304L0.700195 13.3Z",
    fill: "#FF8484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.0c06fdc8ac18bf47feb7e71ce38f7cbd.svg";
export { ForwardRef as ReactComponent };